// CSpell:ignore VPAID, MRAID, ORMMA, DAAST

// Enums from OpenRTB. Reference: https://www.iab.com/wp-content/uploads/2016/03/OpenRTB-API-Specification-Version-2-5-FINAL.pdf

export enum AdPosition {
  Unknown = 0,
  AboveTheFold,
  DEPRECATED,
  BelowTheFold,
  Header,
  Footer,
  Sidebar,
  FullScreen,
}

// https://github.com/InteractiveAdvertisingBureau/AdCOM/blob/master/AdCOM%20v1.0%20FINAL.md#list--placement-subtypes---video-
export enum VideoPlacement {
  InStream = 1,
  InBanner,
  InArticle,
  InFeed,
  Interstitial,
}

// https://github.com/InteractiveAdvertisingBureau/AdCOM/blob/master/AdCOM%20v1.0%20FINAL.md#list--placement-subtypes---video-
export enum VideoPlacementV2 {
  InStream = 1,
  AccompanyingContent,
  Interstitial,
  NoContentOrStandalone,
}

export enum VideoPlaybackMethod {
  PageLoadWithSoundOn = 1,
  PageLoadWithSoundOff,
  ClickWithSoundOn,
  MouseOverWithSoundOn,
  EnterViewportWithSoundOn,
  EnterViewportWithSoundOff,
}

export enum VideoApi {
  VPAID1 = 1,
  VPAID2,
  MRAID1,
  ORMMA,
  MRAID2,
  MRAID3,
}

export enum VideoProtocol {
  VAST1 = 1,
  VAST2,
  VAST3,
  VAST1Wrapper,
  VAST2Wrapper,
  VAST3Wrapper,
  VAST4,
  VAST4Wrapper,
  DAAST1,
  DAAST1Wrapper,
}

export enum VideoSkip {
  No = 0,
  Yes,
}

export enum VideoLinearity {
  Linear = 1,
  NonLinear,
}
